var esus = {
	"coupon-callout": {
	"coupon-code": "Código",
	"coupon-message-with-price": "Tan solo {{ price }}",
	"coupon-expiry-message": "Vence {{ Date }}.",
	"code-at-checkout": "Ingrese el código al finalizar la compra. No puede combinarse con otros códigos promocionales, promociones o descuentos.",
	"cancel-icon": "Cancelar",
	"info-icon": "Ver más detalles",
	"check-icon": "Aplicado",
	"promo-code": "Código promocional",
	"coupon-callout-popover": "Mensaje emergente de cupón"
}
};

export { esus as default };
//# sourceMappingURL=src-localization-texts-es-us.json.js.map
